import { usernameHandleParse, numberHandleParse } from './parsers';

const messengers = {
  whatsapp: {
    title: "WhatsApp",
    fieldType: "number",
    placeholder: "WhatsApp phone number with country code ( +1...)",
    parse: numberHandleParse,
    urlMutator: ({handle, text}) => `https://api.whatsapp.com/send?phone=${(handle || '').replace(/[^0-9]+/gi, '')}&text=${encodeURIComponent(text || '')}`,
    subfields: {
      text: {
        placeholder: "Predefined text: e.g Give me further information about...",
        type: "textarea"
      }
    }
  },
  messenger: {
    title: "Messenger",
    placeholder: "Messenger/Facebook username",
    parse: usernameHandleParse,
    urlMutator: ({handle}) => `https://m.me/${(handle || '').replace(/^@/i, '')}`
  },
  telegram: {
    title: "Telegram",
    placeholder: "Telegram username",
    parse: usernameHandleParse,
    urlMutator: ({handle}) => `https://t.me/${(handle || '').replace(/^@/i, '')}`//,
    //subfields: {
    //  text: {
    //    placeholder: "Predefined text: e.g Give me further information about..."
    //  }
    //}
  },
  skype: {
    title: "Skype",
    placeholder: "Skype username",
    urlMutator: ({handle}) => `skype:${(handle || '').replace(/^@/i, '')}`
  },
  viber: {
    title: "Viber",
    fieldType: "number",
    placeholder: "Viber number",
    parse: usernameHandleParse,
    urlMutator: ({handle}) => `viber://add?number=${(handle || '').replace(/[^0-9]+/gi, '')}`
  },
  
  // wechat: {
  //   title: "WeChat",
  //   fieldType: "number",
  //   placeholder: "WeChat ID",
  //   parse: usernameHandleParse,
  //   urlMutator: ({handle}) => `weixin://dl/chat?${(handle || '').replace(/^@/i, '')}`
  // },
  
  email: {
    title: "Email",
    placeholder: "Email address",
    urlMutator: ({handle, subject, body}) => `mailto:${(handle || '').replace(/\s+/i, '')}?subject=${encodeURIComponent(subject || '')}`,
    subfields: {
      subject: {
        placeholder: "Subject:"
      }
    }
  },
  call: {
    title: "Phone call",
    placeholder: "Phone number with country code ( +1...)",
    parse: numberHandleParse,
    urlMutator: ({handle}) => `tel:${(handle || '').replace(/^@/i, '')}`
  }
}

export default messengers;



// WEBPACK FOOTER //
// ./src/components/SmartLinks/schemes/messengers.js